export enum ExceptionCategory {
    CUSTOMER_ACCOUNT_FAILURE = 'CUSTOMER_ACCOUNT_FAILURE',
    ENROLLMENT = 'ENROLLMENT',
    INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
    LOGIN_FAILURE = 'LOGIN_FAILURE',
    UNAUTHORIZED_ACCESS = 'UNAUTHORIZED_ACCESS'
}
